import { Button, Grid, Typography } from "@mui/material";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useResetPassword } from "./hooks/useResetPassword";
import { Loader } from "@common/Loader/Loader";

export const UserPassword = () => {
    const { resetPassword, resetPasswordState, isLinkSent } = useResetPassword();
    const { t } = useTranslation(["profile", "common"]);

    return (
        <Fragment>
            <Grid alignItems="flex-end" container>
                <Grid item md={4} xs={9}>
                    <Grid container direction="column">
                        <Typography color="textSecondary" id="detailPassword" variant="small">
                            {t("profile:password")}
                        </Typography>
                        <Typography aria-labelledby="detailPassword" variant="normal">
                            **********
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item sm={2} xs={3}>
                    {resetPasswordState.isLoading && <Loader size={40} />}
                    {!resetPasswordState.isLoading && (
                        <Button
                            color="secondary"
                            fullWidth
                            size="large"
                            type="button"
                            variant="contained"
                            onClick={resetPassword}
                        >
                            {t("profile:reset")}
                        </Button>
                    )}
                </Grid>
            </Grid>
            {resetPasswordState.error && (
                <Grid className="mydetail-password__info" item xs={12}>
                    <Typography color="error" variant="normal">
                        {t("common:genericError")}
                    </Typography>
                </Grid>
            )}
            {isLinkSent && (
                <Grid className="mydetail-password__info" item xs={12}>
                    <Typography variant="normal">{t("profile:linkSent")}</Typography>
                    <Typography variant="normal">{t("profile:linkSentHelper")}</Typography>
                </Grid>
            )}
        </Fragment>
    );
};
